/** Eventos de ventana para el bus realtime de soporte (consola admin). */

export const ADMIN_SUPPORT_SSE_MESSAGE = "redipos:admin-support-sse-message";
export const ADMIN_SUPPORT_SSE_TYPING = "redipos:admin-support-sse-typing";
export const ADMIN_SUPPORT_SSE_READ = "redipos:admin-support-sse-read";
export const ADMIN_SUPPORT_THREADS_SYNC = "redipos:admin-support-threads-sync";
export const ADMIN_SUPPORT_ACTIVE_THREAD = "redipos:support-active-thread";
